export default "__VITE_ASSET__489b29e6__$_?react__"